//export const api_url = "http://localhost:3002";
//export const app_url = "http://localhost:3000";
export const api_url = "https://assamcricket.com:3002";
export const app_url = "https://assamcricket.com";
